import t from "./index436.js";
import { resolveComponent as c, createElementBlock as o, openBlock as s, normalizeClass as l, createElementVNode as m, createCommentVNode as a, createVNode as d, toDisplayString as n } from "vue";
/* empty css         */
import h from "./index231.js";
const p = ["data-component"], i = ["href"], _ = {
  key: 0,
  class: "ms-headerLogo__channelLabel"
}, L = {
  key: 1,
  class: "ms-headerLogo__channelLabel"
};
function f(e, g, b, u, N, $) {
  const r = c("MsLogo");
  return s(), o("div", {
    class: l(["ms-headerLogo", {
      "-noLabel": !e.isScreenL && !e.showLabel()
    }]),
    "data-component": e.$options.name
  }, [
    m("a", {
      class: "ms-headerLogo__slogan",
      href: e.href
    }, [
      !e.isScreenL && e.showLabel() ? (s(), o("span", _, n(e.channelName), 1)) : a("", !0),
      d(r, { class: "ms-headerLogo__svg" }),
      e.isScreenL && e.showLabel() ? (s(), o("span", L, n(e.channelName), 1)) : a("", !0)
    ], 8, i)
  ], 10, p);
}
const y = /* @__PURE__ */ h(t, [["render", f], ["__scopeId", "data-v-d9ea6298"]]);
export {
  y as default
};
